import { databases } from './appwriteClient';
import { Query } from 'appwrite';
import { Transaction } from '../types';

const DATABASE_ID = '682acd26001f69683cd8';
const COLLECTION_ID = '6863f9b6001639720d6e';

export const fetchTransactionsForStudent = async (studentId: string): Promise<Transaction[]> => {
  const allTxns: Transaction[] = [];
  let offset = 0;
  const limit = 100;
  while (true) {
    const res = await databases.listDocuments(
      DATABASE_ID,
      COLLECTION_ID,
      [
        Query.equal('student_id', [studentId]),
        Query.limit(limit),
        Query.offset(offset)
      ]
    );
    allTxns.push(...(res.documents as unknown as Transaction[]));
    if (res.documents.length < limit) break;
    offset += limit;
  }
  return allTxns;
}; 